import MeteNavbar from './components/MeteNavbar'
import { CardGroup, Card, Container } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getFirestore, doc, getDoc } from "firebase/firestore";
import MandD from "./images/logos/mete-&-design-logo-stacked-less.png"
import './App.scss';
import MyGify from "./images/gifs/MyGify.gif"
import face from "./images/pieces/Grown_Mete_Mascot.png"
import face2 from "./images/pieces/Smiling_eye_sockets.png"
// import face2Small from "./images/pieces/1x/Smiling eye sockets.png"
import faceAngry from "./images/pieces/Angry_Face_Eye_socket.png"
import leftEye from "./images/left-eye-8.png"
import rightEye from "./images/Right-eye-8.png"
import { AiFillYoutube } from "react-icons/ai"
import { GrTwitter } from "react-icons/gr"
import { GrInstagram } from "react-icons/gr"
import { FaCss3Alt, FaGithub } from "react-icons/fa"
import { ImBehance } from "react-icons/im"
import { GrLinkedinOption } from "react-icons/gr"
import { MdVerifiedUser } from "react-icons/md"
import { FaMediumM } from "react-icons/fa";
import artStation from "./images/icons/FontAwesome-Brands-Artstation.10.png";
import Disc from "./images/icons/discord_circle_white.png"
import contra from "./images/icons/contra_white.png"
import hair from "./images/brushes/Hair-Brushes-thumbnails.png"
import scratch from "./images/brushes/woodchip-brushes.png"
import socio from "./images/brushes/smoke-brushes.png"
import rhythm from "./images/gifs/Rhythm_1.gif"
import demon from "./images/gifs/Vs_1.mp4"
import vs from "./images/gifs/TheWhole_1.gif"
import barrel from "./images/3D/Barrels.png"
import bark from "./images/3D/Bark.png"
import grass from "./images/3D/Grass golfball.png"
import MeteFooter from './components/MeteFooter';
import { gsap, Power3 } from 'gsap';
import { useRef, useEffect, useState } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { HiDocumentDownload } from "react-icons/hi"
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import { DiGithubBadge, DiHtml5, DiJavascript, DiNodejs, DiNpm } from "react-icons/di";
import { FaReact } from "react-icons/fa";
import { BiLogoBlender } from "react-icons/bi";
import { SiAdobephotoshop } from "react-icons/si"
import { SiAdobeillustrator } from "react-icons/si"
import { CgFigma } from "react-icons/cg"
import { SiAdobepremierepro } from "react-icons/si"
import { SiAdobeindesign } from "react-icons/si";
import useFirestore from './hooks/useFirestore';
import { firestore } from './Firebase/Firebase'; // path to your firebase.js
import PhotoSkeleton from './components/skeletons/PhotoSkeleton';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PersonalLifeCarousel from './components/PersonalLifeCarousel';
import 'react-lazy-load-image-component/src/effects/blur.css';



gsap.registerPlugin(ScrollTrigger);



const getFileType = (url) => {
  const extensionMatch = url.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
  const extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';

  switch (extension) {
    case 'pdf':
      return 'PDF Document';
    case 'jpg':
    case 'jpeg':
    case 'png':
      return 'Image';
    case 'mp3':
      return 'Audio';
    case 'mp4':
      return 'Video';
    case 'zip':
      return 'ZIP Archive';
    case 'psd':
      return 'PSD';
    case 'blend':
    case 'blend1':
      return 'BLEND';
    case 'prproj':
      return 'Premiere Pro';
    case 'aep':
      return 'After Effects';
    case 'abr':
      return 'Photoshop Brush';
    // Add more cases as needed
    default:
      return 'Unknown File Type';
  }
};

function useExperience(startYear) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const startDate = new Date(`${startYear}-01-01`);

  // Calculate total years difference
  let years = currentYear - startDate.getFullYear();

  // Determine if current year is complete
  const isYearComplete = currentDate.getMonth() === 11 && currentDate.getDate() === 31;

  return `${years}${isYearComplete ? "" : "+"}`;
}

function App() {


  useEffect(() => {
    document.title = "Home Page | mete & design."; // or whatever is appropriate
  }, []);

  const colors = ["#B8FE4E", "#FEEC4E"];

  window.addEventListener("mousedown", (e) => {
    const color = colors.shift();
    document.documentElement.style.setProperty("--highlight-color", color);
    colors.push(color);
  });

  const TextCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Text copied to clipboard');
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
      });
  };

  const experience = useExperience(2017);


  const [cvUrl, setCvUrl] = useState('');

  useEffect(() => {
    const fetchCV = async () => {
      const db = getFirestore();
      const cvDoc = doc(db, "CV", "cv1"); // Replace with your Firestore collection and document ID
      const cvSnapshot = await getDoc(cvDoc);

      if (cvSnapshot.exists()) {
        setCvUrl(cvSnapshot.data().Url); // Assuming your document has a field named 'cvUrl'
      } else {
        console.log("No such document!");
      }
    };

    fetchCV();
  }, []);

  const [loading, setLoading] = useState(true);
  const { docs } = useFirestore('Portfolio');
  const [collabs, setCollabs] = useState([]);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchCollaborators = async () => {
      try {
        const snapshot = await firestore.collection('collaborators').orderBy('AltText', 'asc').get();
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCollabs(data);
      } catch (error) {
        console.error("Error fetching collaborators:", error);
      }
    };

    fetchCollaborators();
  }, []);


  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const snapshot = await firestore
          .collection("personalGallery")
          .orderBy("timestamp", "desc")
          .get();
        const fetchedPhotos = snapshot.docs.map((doc) => doc.data());
        setPhotos(fetchedPhotos);
      } catch (error) {
        console.error("Error fetching photos:", error);
      }
    };
    fetchPhotos();
  }, []);
  const [activePhoto, setActivePhoto] = useState(null);

  const handleBackdropClick = () => {
    setActivePhoto(null);
  };

  const handleContextMenu = (e) => {
    e.preventDefault(); // Prevent the default context menu behavior
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setActivePhoto(null);
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);




  // Double the array for seamless looping
  const doubledPhotos = [...photos, ...photos];


  //to shuffle the images on landing page
  useEffect(() => {
    if (docs.length > 0) {
      // Shuffle using Fisher-Yates algorithm
      const shuffled = [...docs];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      setImages(shuffled.slice(0, 6)); // Take the first 6 randomly shuffled items
    }
  }, [docs]);



  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  const [expression, setExpression] = useState('default');

  let bigCircle = useRef(null);
  let medCircle = useRef(null);
  let smallCircle = useRef(null);
  let head = useRef(null);
  let leftEyeRef = useRef(null);
  let rightEyeRef = useRef(null);
  let headlineFirst = useRef(null);
  let headlineSecond = useRef(null);
  let smallHeadline = useRef(null);
  let headlineButton = useRef(null);
  let socialNav = useRef(null);
  let socials = useRef(null);
  let socialyRef = useRef(null);
  let serviceRef = useRef(null);
  let PortRef = useRef(null);
  const form = useRef();


  //gsap code
  useEffect(() => {
    //content variables
    let ctx = gsap.context(() => {
      gsap.to(".App", { duration: .0, css: { visibility: 'visible' } });
      if (bigCircle != null) {
        gsap.from([bigCircle, medCircle, smallCircle, head.children], { duration: .8, opacity: 0, x: 140, ease: Power3.easeOut, stagger: .2 })


        // Text animations
        const localTimeline = gsap.timeline({ delay: 0.8 });
        localTimeline.from([headlineFirst, headlineSecond, smallHeadline, headlineButton],
          { duration: 1, y: 44, opacity: 0, ease: Power3.easeOut, stagger: 0.1, delay: .8 }, .15)

        localTimeline.from([socials.children],
          { duration: 1, x: -44, opacity: 0, ease: Power3.easeOut, stagger: 0.1, delay: 0.5 }, .15)

        localTimeline.from([socialNav.children],
          { duration: 1, y: 44, opacity: 0, ease: Power3.easeOut, stagger: 0.1, delay: 0.2 }, .15)
      }

      gsap.fromTo([serviceRef.children], { opacity: 0, y: 124 }, {
        duration: 1, y: 0, opacity: 1, ease: Power3.easeOut, stagger: 0.1, delay: 0.3, scrollTrigger: {
          trigger: serviceRef.children,
          start: 'bottom top+=700',
          toggleActions: "restart none none none",
          //            onEnter   onLeave  onEnterBack   onLeaveBack
        }
      })
      gsap.fromTo([PortRef.children], { opacity: 0, y: 124 }, {
        duration: 1, y: 0, opacity: 1, ease: Power3.easeOut, stagger: { each: 0.1, from: "start" }, delay: 0.9, scrollTrigger: {
          trigger: PortRef.children,
          start: 100,
          toggleActions: "restart none none none",
        }
      })

      // Set initial position and opacity
      gsap.set(socialyRef, { y: 0, opacity: 1 });

      gsap.fromTo([socialyRef], { opacity: 1, y: 0 }, {
        duration: 1, y: 100, opacity: 1, ease: Power3.easeOut,
        scrollTrigger: {
          trigger: socialyRef,
          start: 'bottom top+=700', // When to start the animation
          end: '+=700', // When to end the animation
          scrub: true, // Smooth scrolling effect
          toggleActions: "play reverse none none",
        }
      })
    })



    const handleMouseMove = (e) => {
      const mouseX = e.clientX;
      const mouseY = e.clientY;

      const anchor = document.getElementById('anchor');
      const rekt = anchor.getBoundingClientRect();

      const eyes = [leftEyeRef.current, rightEyeRef.current];
      eyes.forEach((eye) => {
        const eyeRekt = eye.getBoundingClientRect();
        const eyeCenterX = eyeRekt.left + eyeRekt.width / 2;
        const eyeCenterY = eyeRekt.top + eyeRekt.height / 2;

        const dx = mouseX - eyeCenterX;
        const dy = mouseY - eyeCenterY;
        const distance = Math.sqrt(dx * dx + dy * dy);

        const maxDistance = Math.min(rekt.width, rekt.height) * 0.2;
        const maxTranslate = 12;
        const translate = Math.min(distance * (maxTranslate / maxDistance), maxTranslate);

        eye.style.transform = `translate(${(dx / distance) * translate}px, ${(dy / distance) * translate}px)`;
      });
    };

    const handleMouseLeaveDoc = () => {
      const eyes = [leftEyeRef.current, rightEyeRef.current];
      eyes.forEach((eye) => {
        eye.style.transform = '';
      });
    };

    const handleFaceEnter = () => setExpression('surprised');
    const handleFaceLeave = () => setExpression('default');

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeaveDoc);

    const anchorImage = document.getElementById('anchor');
    if (anchorImage) {
      anchorImage.addEventListener('mouseenter', handleFaceEnter);
      anchorImage.addEventListener('mouseleave', handleFaceLeave);
    }

    return () => {
      ctx.revert();
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeaveDoc);

      if (anchorImage) {
        anchorImage.removeEventListener('mouseenter', handleFaceEnter);
        anchorImage.removeEventListener('mouseleave', handleFaceLeave);
      }
    };
  }, []);




  const notifySuccess = () => {
    toast.success('Message Sent!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  const notifyUnSuccess = () => {
    toast.error('Message Unable to Send!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_336nw3g', 'template_6c7nozs', form.current, 'Cw1kpSd6Q5Hi8XGhT')
      .then((result) => {
        console.log(result.text);
        notifySuccess();

        // Retrieve user input from the form
        const userName = form.current.user_name.value;
        const userEmail = form.current.user_email.value;

        // Check for user consent (you can implement a modal or checkbox for this)
        const userConsent = true; // Replace with actual consent logic

        if (userConsent) {
          // Set cookies with user's name and email
          Cookies.set('userNameCookie', userName, { sameSite: 'None', secure: true });
          Cookies.set('userEmailCookie', userEmail, { sameSite: 'None', secure: true });
        } else {
          console.log("User did not consent to cookies.");
        }

      }, (error) => {
        console.log(error.text);
        notifyUnSuccess();
      });
    form.current.reset();

  }


  const skillItems = [
    <DiHtml5 />,
    <FaCss3Alt />,
    <DiJavascript />,
    <BiLogoBlender />,
    <FaReact className="roll" />,
    <SiAdobephotoshop />,
    <SiAdobeillustrator />,
    <SiAdobepremierepro />,
    <SiAdobeindesign />,
    <DiNpm />,
    <DiNodejs />,
    <DiGithubBadge />,
    <CgFigma />
  ];

  const isLessThan9 = skillItems.length < 9;

  useEffect(() => {
    //makes page be at top when browser refreshed
    window.history.scrollRestoration = 'manual'
  }, []);




  //39aa361a81e1aa241b8e8824dd5c5eee-us14
  //mailchimp api key

  return (
    <div className="App" id='home'>
      <MeteNavbar />
      <div className="firstSec" >
        <Container className='firstSec-container' >
          <Row className='firstSec-row'>
            <Col className='firstSec-col1'>
              <div className="firstSec-inner" >
                <h1 ref={el => { headlineFirst = el }}>Look, See &</h1>
                <h1 ref={el => { headlineSecond = el }} className='logo-greet'>Feel Design</h1>
                <div className="myp">
                  <p ref={el => { smallHeadline = el }}>I’m Mete Oyama, a Multidisciplinary Brand Identity Designer with Front-End Expertise, specializing in Graphic Design, UI/UX, Web Programming, and 3D Design.
                  </p>
                </div>
                <button className='learnBtn' ref={el => { headlineButton = el }}><a href='#AboutMe'>Learn More</a></button>
                <div className="socials">
                  <Container className='socials-cont'>
                    <Row>
                      <Col className='inner-col' ref={el => { socials = el }}>
                        <div className="box"><a href='https://www.youtube.com/@meteanddesign' rel="noreferrer" target="_blank" aria-label="Youtube"><AiFillYoutube /></a></div>
                        <div className="box"><a href='https://twitter.com/meteoyama' rel="noreferrer" target="_blank" aria-label="Twitter"><GrTwitter /></a></div>
                        <div className="box"><a href='https://www.instagram.com/mete_and_design/' rel="noreferrer" target="_blank" aria-label="Instagram"><GrInstagram /></a></div>
                        <div className="box"><a href='https://github.com/mylesodey' rel="noreferrer" target="_blank" aria-label="Github"><FaGithub /></a></div>
                        <div className="box"><a href='https://www.behance.net/meteoyama22/' rel="noreferrer" target="_blank" aria-label="Behance"><ImBehance /></a></div>
                        <div className="box"><a href='https://www.linkedin.com/in/mete-oyama-6a8a22177' rel="noreferrer" target="_blank" aria-label="LinkedIn"><GrLinkedinOption /></a></div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
              <div className='staticAnchor'>
                <div ref={el => { head = el }} className={`imagen face ${expression}`}>
                  {/* <img src={expression === 'default' ? face2 : face} alt="mete" id='anchor' /> */}
                  <img
                    src={expression === 'default' ? face2 : faceAngry}
                    // srcSet={`${face2Small} 800w, ${face2} 1599w, ${faceAngry} 1599w`}
                    // sizes="(max-width: 800px) 8800px, 1599px"
                    alt="mete"
                    id="anchor"
                  />
                  <img src={face} alt="mete" id='anchor2' className={'tabShow'} />

                  <img src={leftEye} alt="left eye" className='leftEye eye' ref={leftEyeRef} />
                  <img src={rightEye} alt="right eye" className='rightEye eye' ref={rightEyeRef} />

                </div>
              </div>

              <div className="bgCircles">
                <div className="circle-big" ref={el => { bigCircle = el }}></div>
                <div className="circle-medium" ref={el => { medCircle = el }}></div>
                <div className="circle-small" ref={el => { smallCircle = el }}></div>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
      <section className="social-nav" ref={el => { socialNav = el }}>
        <div className="inner-socials" ref={el => { socialyRef = el }}>
          <a href="https://contra.com/mete_wkx7c7q7?referralExperimentNid=SOCIAL_REFERRAL_PROGRAM&referrerUsername=mete_wkx7c7q7" rel="noreferrer" target="_blank" aria-label="Contra"><img src={contra} alt="Contra" /><p><small>Connect with me on</small> Contra</p></a>
          <a href="https://discord.gg/Mg9ksGYcRF" rel="noreferrer" target="_blank" aria-label="Discord"><img src={Disc} alt="behance circle" /><p><small>Connect with me on</small> Discord</p></a>
          <a href="https://medium.com/@meteanddesign" rel="noreferrer" target="_blank" aria-label="Medium"><FaMediumM className='medi' alt="dribble" /><p><small>Connect with me on</small> Medium</p></a>
          <a href="https://www.artstation.com/mete_and_design" rel="noreferrer" target="_blank" aria-label="Art Station"><img src={artStation} alt="art station" /><p><small>Connect with me on</small> Art Station</p></a>
        </div>
      </section>
      <section className="cutscene">

      </section>

      <Container className='line-break-container'>
        <div className="line-break"><div className="line-inner"></div></div>
      </Container>

      <section className='portfolio-section' id='Portfolio'>
        <Container>
          <div className="heading" >
            <h2>Portfolio</h2>
            <p>Here are some of my works i've done over the years for satisfied Clients. </p>
          </div>
        </Container>
        <Container>
          <div className="packs">
            <Row >
              <Col ref={el => { PortRef = el }}>
                <CardGroup className='cardhi '>
                  {images.map((item) => (
                    <Card key={item.id} className='imageCard'>
                      <Card.Body className='imageCardBody'>
                        <Card.Title className='imageCardHead'> <h2>{item.Title}</h2> <span><div className="circle"><div className="circle-inner"></div></div></span> </Card.Title>

                        <Card.Text className='imageCardText'>
                          <span className="imageTe">
                            <span>{item.Detail}<span><MdVerifiedUser /></span> </span>

                          </span><br />
                          <span className='imageID'>{item.ImageID}</span>
                        </Card.Text>
                        <div className="line"><div className="line-inner"></div></div>
                        <div className="imageHold">
                          {loading ? (
                            <PhotoSkeleton />
                          ) : getFileType(item.PhotoUrl) === 'Video' ? (
                            <video

                              muted
                              autoPlay
                              loop
                              className='videoImg'
                              loading="lazy"

                            >
                              <source src={item.PhotoUrl} type="video/mp4" />
                            </video>
                          ) : (
                            <LazyLoadImage
                              src={item.PhotoUrl}
                              alt={item.title || 'Portfolio Image'}
                              className='imageImg'

                              effect="blur"

                            />
                          )}



                        </div>
                      </Card.Body>
                    </Card>


                  ))}
                </CardGroup>
              </Col>
            </Row>

            <div className="btn-hold">
              <Link to="/portfolio">
                <button className='myBtn'>See All</button>
              </Link>
            </div>
          </div>
        </Container>
      </section>


      <Container className='line-break-container'>
        <div className="line-break"><div className="line-inner"></div></div>
      </Container>

      <section className="asset-section">
        <Container>
          <div className="heading">
            <h2>Assets</h2>
            <p>A Bookshelf of valuable/useful assets for your designs</p>
          </div>
        </Container>
        <Container>
          <div className="asset-packs">
            <Row>
              <Col>
                <CardGroup className='cardni'>
                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={hair}
                          alt="Hair Brush"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> Photoshop Brush </Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Hair Photoshop Brushes
                          Preset</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={scratch}
                          alt="Woodchip Brush"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>
                      <Card.Title className='assetCardHead'> Photoshop Brush</Card.Title>
                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Woodchip Photoshop Brushes
                          Preset</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={socio}
                          alt="Smoke Brushes"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> Photoshop Brush </Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Smoke Photoshop Brush
                          Preset</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  {/*Videos */}

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={rhythm}
                          alt="rhythm"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> Video Edit</Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Wavy Typography Template</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>
                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :
                        <video src={demon} muted autoPlay loop className='imageImg' loading="lazy">

                        </video>
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> Video Edit </Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Versus Battle Video Template </span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={vs}
                          alt="vs"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'>Video Edit</Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Movie Intro template mockup</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  {/*3D Assets */}

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={grass}
                          alt="grass"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> 3D Asset </Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Golf Ball on Grass 3D Model</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :


                        <LazyLoadImage
                          src={barrel}
                          alt="barrel"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> 3D Asset </Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>3D models of a Barrel</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                  <Card className='assetCard'>
                    <div className="assetHold">
                      {loading ? <PhotoSkeleton /> :

                        <LazyLoadImage
                          src={bark}
                          alt="bark"
                          className='imageImg'

                          effect="blur"

                        />
                      }
                    </div>
                    <Card.Body className='assetCardBody'>

                      <Card.Title className='assetCardHead'> 3D Asset</Card.Title>

                      <Card.Text className='assetCardText'>
                        <span className='assetTe'>Bark Material using Geometry Nodes</span>
                      </Card.Text>
                      <div className="line"><div className="line-inner"></div></div>

                    </Card.Body>
                  </Card>

                </CardGroup>
              </Col>
            </Row>
            <div className="btn-hold">
              <Link to="/store"> {/* Updated link to redirect to the store page */}
                <button className='myBtn'>Visit Store</button>
              </Link>
            </div>
          </div>
        </Container>
      </section>

      <Container className='line-break-container'>
        <div className="line-break"><div className="line-inner"></div></div>
      </Container>

      <section className='service-sec' id='Services'>
        <Container>
          <div className="heading" >
            <h2>Services</h2>
            <p>Hire me for awesome projects.</p>
          </div>
          <div className="cards">
            <CardGroup >
              <Row xs={1} md={2} lg={2} className="g-4" ref={el => { serviceRef = el }}>

                <Col className='cardup'>
                  <Card className='myCard serviceCard'  >

                    <Card.Body className='myCardBody'>
                      <Card.Title className='myCardHead'> <h2>Graphic Design</h2> <span><div className="circle"><div className="circle-inner"></div></div></span></Card.Title>
                      <div className="line"><div className="line-inner"></div></div>
                      <Card.Text className='myCardText'>
                        From branding to digital assets, I craft visual identities that communicate clearly and stand out. My work spans logo design, typography, layouts, and visual systems that are both strategic and expressive. Whether you need a complete brand refresh or compelling visuals for your next campaign, I deliver design that connects with your audience.
                      </Card.Text>

                    </Card.Body>
                  </Card>
                </Col>
                <Col className='cardup'>
                  <Card className='myCard serviceCard'>
                    <Card.Body className='myCardBody'>
                      <Card.Title className='myCardHead'> <h2>UI/UX Design</h2> <span><div className="circle"><div className="circle-inner"></div></div></span> </Card.Title>
                      <div className="line"><div className="line-inner"></div></div>
                      <Card.Text className='myCardText'>
                        I design intuitive user interfaces that balance form and function. My process blends user research, wireframing, and high-fidelity prototyping to create digital products that are easy to use and visually engaging. Every detail — from layout to micro-interaction — is crafted to enhance the user journey and make interfaces feel effortless and enjoyable.
                      </Card.Text>

                    </Card.Body>
                  </Card>
                </Col>

                <Col className='cardup'>
                  <Card className='myCard serviceCard'>
                    <Card.Body className='myCardBody'>
                      <Card.Title className='myCardHead'> <h2>3D Modelling</h2> <span><div className="circle"><div className="circle-inner"></div></div></span> </Card.Title>
                      <div className="line"><div className="line-inner"></div></div>
                      <Card.Text className='myCardText'>
                        I use 3D to add subtle depth and motion to digital content. With tools like Blender, I create stylized models and simple animations — such as logo reveals, spin effects, and motion loops — that enhance visual storytelling. It’s a playful way to make designs feel more dynamic and alive, especially across web and branding projects.
                      </Card.Text>

                    </Card.Body>
                  </Card>
                </Col>
                <Col className='cardup'>
                  <Card className='myCard serviceCard'>
                    <Card.Body className='myCardBody'>
                      <Card.Title className='myCardHead'> <h2>Web Development</h2> <span><div className="circle"><div className="circle-inner"></div></div></span> </Card.Title>
                      <div className="line"><div className="line-inner"></div></div>
                      <Card.Text className='myCardText'>
                        I design and build modern, responsive websites using React JS, combining clean code with thoughtful design. From the initial concept to the final product, I focus on creating seamless user experiences that work beautifully across all devices. My process includes front-end development with HTML, CSS, and JavaScript, as well as integrating back-end services, content management systems, and e-commerce solutions when needed. Whether it’s a dynamic web app or a sleek portfolio site, I make sure it’s fast, accessible, and aligned with your goals.


                      </Card.Text>

                    </Card.Body>
                  </Card>
                </Col>

              </Row>
            </CardGroup>
          </div>
        </Container>
      </section>

      <Container className='line-break-container'>
        <div className="line-break"><div className="line-inner"></div></div>
      </Container>



      <section className="aboutMe-section" id='AboutMe'>
        <Container className="about-inner">
          <Row className='about-orient'>
            <Col >
              <div className="imagery">

                <Card className='imageryCard'>
                  <Card.Img src={MyGify} alt="Mete Oyama" loading="lazy"></Card.Img >
                </Card>

              </div>
            </Col>
            <Col lg={8}>
              <div className="about-text">
                <h3>About Me</h3>
                <p className='desc'>Freelance Product Designer</p>
                <p className='spit'>Hello there! I'm Mete Oyama,I’m a multidisciplinary brand identity designer with over <strong><span>{experience}</span> years of experience</strong> creating impactful visual identities, user interfaces, and web experiences. My work combines strong fundamentals in graphic design and branding with technical skills in React.js development and 3D product visualization focused on realism and precision.

                  I’ve designed complete brand systems and guidelines, built interactive web applications from scratch, and crafted detailed UI components with a focus on visual harmony and usability. My goal is to bridge the gap between design and function — crafting brands that not only look exceptional but also perform seamlessly across digital platforms.

                </p>

              </div>
            </Col>
          </Row>
          <Row xs={1} md={1} lg={2}>
            <Col>
              <p className='spit-continue'>

                Over the years, I've honed my skills, delving into design fundamentals and mastering various tools. Collaboration and staying updated with industry trends have been pivotal to my growth.

                I believe in the power of design to shape perceptions and connect with people on a deep level. Whether it's crafting logos, designing websites, or developing branding strategies, I'm dedicated to creating impactful design solutions.

                My journey as a multidisciplinary brand identity designer has been filled with challenges, achievements, and continuous growth. I'm excited to keep pushing the boundaries of design and explore new creative avenues. If you're looking for a skilled designer to bring your vision to life, let's collaborate on this creative journey together with "Mete & Design."</p>
            </Col>

            <Col >
              <div className="imagery2">

                <Card className='imageryCard2'>
                  <Card.Img src={MandD} alt="mete-and-design-official-logo" loading="lazy"></Card.Img>
                </Card>

              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="cv">
                <p><a href={cvUrl} target="_blank" rel="noopener noreferrer">Download my CV <HiDocumentDownload /></a></p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="skills">
                <div className="skills-heading">
                  <h4>Main Skills & Tools</h4>
                </div>
                <div className="allSkills">
                  <Row xs={1} md={4}>
                    <Col>
                      <p>Graphic Design,</p>
                      <p>UI/UX Design,</p>
                      <p>Video Editing,</p>
                      <p>3D Modelling</p>
                    </Col>
                    <Col>
                      <p>Front-End Programming,</p>
                      <p>Web Design</p>
                      <p>Agile Methodology</p>
                      <p>Research</p>

                    </Col>
                    <Col>
                      <p>HTML, CSS, SCSS,</p>
                      <p>JavaScript, React Js,</p>
                      <p>Gsap</p>

                    </Col>
                    <Col>
                      <p>Photoshop, Illustrator,</p>
                      <p>Figma, Blender,</p>
                      <p>After Effects,</p>
                      <p>Premiere Pro</p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
          <div className={`skill-logos${isLessThan9 ? 'centered' : ''}`}>
            {skillItems.map((icon, index) => (
              <div className="skill-logo-item" key={index}>
                {icon}
              </div>
            ))}
          </div>
          <Row>
            <Col>
              <div className="stats">
                <Container className='stats-cont'>
                  <div className="stats-inner">
                    <h3>1</h3>
                    <p>Sponsor</p>
                  </div>
                  <div className="stats-inner">
                    <h3>76+</h3>
                    <p>Clients</p>
                  </div>
                  <div className="stats-inner">
                    <h3>100%</h3>
                    <p>Satisfaction</p>
                  </div>
                  <div className="stats-inner">
                    <h3>140+</h3>
                    <p>Projects</p>
                  </div>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="companies-section">
        <Container>
          <Row>
            <Col>
              <div className="companies-inner">
                <div className="comp-heading">
                  <p>Some Clients from Past Design Collaborations</p>
                </div>
                <div className="comp-surr">
                  <div className="comp-logo-hold">
                    <Row>
                      {collabs.map(collab => (
                        <Col className='space' key={collab.id}>
                          <div className="ght"  >
                            <img src={collab.Url} alt={collab.AltText} title={collab.AltText} />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="discord-section">
        <Container className="discord-cont">
          <div className="heading">
            <h2>Beyond the Screen</h2>
          </div>
          <div className="relative w-full overflow-visible py-4">
            <div className="carousel-wrapper">
              <div className="carousel-marquee">
                {/* First track (accessible) */}
                <div className="carousel-track">
                  {doubledPhotos.map((photo, index) => (
                    <img
                      key={`img-${index}`}
                      src={photo.imageUrl}
                      alt={photo.caption || "Photo"}
                      className="imago"
                      onClick={() => setActivePhoto(photo)}
                    />
                  ))}
                </div>

                {/* Second track (visual only) */}
                <div className="carousel-track" aria-hidden="true">
                  {doubledPhotos.map((photo, index) => (
                    <img
                      key={`clone-${index}`}
                      src={photo.imageUrl}
                      alt={photo.caption || "Photo"}
                      className="imago"
                      onClick={() => setActivePhoto(photo)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>

        <AnimatePresence>
          <PersonalLifeCarousel show={!!activePhoto} onClose={handleBackdropClick}
            onContextMenu={handleContextMenu} photo={activePhoto} />


        </AnimatePresence>

      </section>

      <section className='HireMe-section' id='HireMe'>
        <Container className='HireMe-Container'>
          <Row>
            <Col>
              <div className="contacts">
                <Row>
                  <Col>
                    <div className="contact-holder">
                      <h4>Chat with me on Whatsapp</h4>
                      <p>Mon-Fri from 8am - 5pm</p>
                      <a href="https://wa.me/message/2OW2TYEQPAZ2E1" rel="noreferrer" target="_blank" className='user-select-all' title="Click to copy and go to whatsapp" onClick={TextCopy}>+234 707 214 1007</a>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="contact-holder">
                      <h4>Message me by Email</h4>
                      <p>Mon-Fri from 8am - 5pm</p>
                      <p className='user-select-all' title="Click to copy" onClick={TextCopy}>meteanddesign@gmail.com</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="contact-holder">
                      <h4>Call me</h4>
                      <p>Mon-Fri from 8am - 5pm</p>
                      <p className='user-select-all' title="Click to copy" onClick={TextCopy}>+234 707 214 1007</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xl={6}>


              <div className="holdAllHire">
                <div className="HireHeading">
                  <h4>You Like what you see?  Hire me for your next project.</h4>
                </div>
                <div className="formHere">
                  <form ref={form} onSubmit={sendEmail} className='HireForm'>

                    <label className='textual' htmlFor="user_name">Name</label>
                    <input className='inputs' type="text" name="user_name" id="user_name" required />
                    <label className='textual' htmlFor="user_email">Email</label>
                    <input className='inputs' type="email" name="user_email" id="user_email" required />
                    <label className='textual' htmlFor="message">Message</label>
                    <textarea name="message" className="textera" id="message" required />
                    <div className="but-space">
                      <input type="submit" value="Send" className='myBtn buttonHere' />
                    </div>
                  </form>
                  <ToastContainer className="toastContainer" />
                </div>
              </div>
            </Col>
          </Row>
          <MeteFooter />
        </Container>
      </section>




    </div>
  );
}

export default App;
